import { Map } from 'immutable';

import { ActionKeys, DesktopStateKeys } from './constants';
import * as D from './deps';

const INITIAL_STATE = Map({
  [DesktopStateKeys.DEEP_LINK_PATH]: '',
  [DesktopStateKeys.SOURCE_PATH]: '',
});

// DESKTOP REDUCER
export default D.createReducer(INITIAL_STATE, {
  [ActionKeys.SET_DEEP_LINK_PATH]: setDeepLinkPath,
  [ActionKeys.SET_SOURCE_PATH]: setSourcePath,
});

function setDeepLinkPath(state, { payload }) {
  return state.set(DesktopStateKeys.DEEP_LINK_PATH, payload.deepLinkPath);
}

function setSourcePath(state, { payload }) {
  return state.set(DesktopStateKeys.SOURCE_PATH, payload.sourcePath);
}
